(function($) {
  "use strict";

  function stickyHeader() {
 if ($('.header-sticky').length) {

    $(window).scroll(function() {
      if( $(this).scrollTop() > 400 ) {
        $('.header-sticky ').addClass('fixed');
        $('body').css('margin-top', '100px');
      } else {
        $('.header-sticky ').removeClass('fixed');
        $('body').css('margin-top','0px');
      }
   });
        }

  }
  function search(){
      // Popup for Menu and Search Links in the Header
        $('.search-toggle').on('click', function () {
          $('.home-search').fadeIn(250);
          $('.home-search .search-query').focus();
        });
        $('.close-search').on('click', function () {
          $('.home-search').fadeOut(250);
        });
    }
  function faq(){
    var Accordion = function(el, multiple) {
      this.el = el || {};
      this.multiple = multiple || false;

      // Variables privadas
      var links = this.el.find('.link');
      // Evento
      links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
    }

    Accordion.prototype.dropdown = function(e) {
      var $el = e.data.el;

      $(this).next().slideToggle();
      $(this).parent().toggleClass('open');

      if (!e.data.multiple) {
        $el.find('.submenu').not($(this).next()).slideUp().parent().removeClass('open');
      };
    }	

    var accordion = new Accordion($('#accordion'), false);

  }
  function masonry() {
    var masonryTrigger = $('.ps-masonry');
    if (masonryTrigger.length > 0) {
      masonryTrigger.imagesLoaded(function() {
        masonryTrigger.masonry({
          columnWidth: '.grid-sizer',
          itemSelector: '.grid-item'
        });
      });
      var filters = masonryTrigger.closest('.masonry-root').find('.ps-masonry__filter > li > a');
      filters.on('click', function() {
        var selector = $(this).attr('data-filter');
        filters.find('a').removeClass('current');
        $(this).parent('li').addClass('current');
        $(this).parent('li').siblings('li').removeClass('current');
        $(this).closest('.masonry-root').find('.ps-masonry').isotope({
          itemSelector: '.grid-item',
          isotope: {
            columnWidth: '.grid-sizer'
          },
          filter: selector
        });
        return false;
      });
    }
  }
  function backToTop() {
    var scrollPos = 0;
    var element = $('#back2top');
    $(window).scroll(function() {
      var scrollCur = $(window).scrollTop();
      if (scrollCur > scrollPos) {
        // scroll down
        if (scrollCur > 500) {
          element.addClass('active');
        } else {
          element.removeClass('active');
        }
      } else {
        // scroll up
        element.removeClass('active');
      }

      scrollPos = scrollCur;
    });

    element.on('click', function() {
      $('html, body').animate({
        scrollTop: '0px'
      }, 800);
    })
  }
  function headerToggle() {
    $('.dropdown-toggle').on("click", function (e) {
      $('.dropdown-content').stop().slideUp(300);
      $(this).next().stop().slideToggle(300);
      e.preventDefault();
    }); 
//     $('.dropdown-content li').on("click", function () {
//       $(this).parent().slideUp(300);
//     }); 
  }
  function filter_sidebar() {
    $('.filter-toggle').on("click", function (e) {
      $('body').addClass('show');
    }); 
      $('.exit-canvas').on("click", function (e) {
      $('body').removeClass('show');
    }); 
  }
  function view_column() {
    if ($('.collection-view').length > 0) {
      $('.collection-view a').on("click", function (e) {
      var col = $(this).data('col');
      $('.collection-view a').removeClass('active');
      $(this).addClass('active');
      $('.products-grid').removeClass('two three four five six');
      $('.products-grid').addClass(col);
    }); 
    }
  }
  function sticky_sidebar() {
	if ($('.ps-sticky').length) {
      var checkPoint = 1200,
                windowWidth = $(window).innerWidth();
            // mobile
            if (checkPoint > windowWidth) {
                var stickySidebar = new StickySidebar('.ps-sticky .ps-sticky__target');
                stickySidebar.destroy();
            }
            else {
                var sticky = $('.ps-sticky');
                if (sticky.length > 0) {
                    var sticky_init = new StickySidebar('.ps-sticky .ps-sticky__target', {
                        topSpacing: 20,
                        bottomSpacing: 20,
                        containerSelector: '.ps-sticky'
                    });
                }
            }
    }
    
    }
  function portfolio(){
  // init Isotope
    if($('.isotope').length){
    var $container = $('.isotope').isotope({
    itemSelector: '.element-item',
    layoutMode: 'fitRows',
    getSortData: {
      name: '.name',
      symbol: '.symbol',
      number: '.number parseInt',
      category: '[data-category]',
      weight: function(itemElem) {
        var weight = $(itemElem).find('.weight').text();
        return parseFloat(weight.replace(/[\(\)]/g, ''));
      }
    }
  });

  // filter functions
  var filterFns = {
    // show if number is greater than 50
    numberGreaterThan50: function() {
      var number = $(this).find('.number').text();
      return parseInt(number, 10) > 50;
    },
    // show if name ends with -ium
    ium: function() {
      var name = $(this).find('.name').text();
      return name.match(/ium$/);
    }
  };

  // bind filter button click
  $('#filters').on('click', 'button', function() {
    var filterValue = $(this).attr('data-filter');
    // use filterFn if matches value
    filterValue = filterFns[filterValue] || filterValue;
    $container.isotope({
      filter: filterValue
    });
  });

  // bind sort button click
  $('#sorts').on('click', 'button', function() {
    var sortByValue = $(this).attr('data-sort-by');
    $container.isotope({
      sortBy: sortByValue
    });
  });

  // change is-checked class on buttons
  $('.button-group').each(function(i, buttonGroup) {
    var $buttonGroup = $(buttonGroup);
    $buttonGroup.on('click', 'button', function() {
      $buttonGroup.find('.is-checked').removeClass('is-checked');
      $(this).addClass('is-checked');
    });
  });

  //****************************
  // Isotope Load more button
  //****************************
  var initShow = 12; //number of items loaded on init & onclick load more button
  var counter = initShow; //counter for load more button
  var iso = $container.data('isotope'); // get Isotope instance

  loadMore(initShow); //execute function onload

  function loadMore(toShow) {
    $container.find(".hidden").removeClass("hidden");

    var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function(item) {
      return item.element;
    });
    $(hiddenElems).addClass('hidden');
    $container.isotope('layout');

    //when no more to load, hide show more button
    if (hiddenElems.length == 0) {
      jQuery("#load-more").hide();
    } else {
      jQuery("#load-more").show();
    };

  }

  //append load more button
  $container.after('<button id="load-more"> Load More</button>');

  //when load more button clicked
  $("#load-more").click(function() {
    if ($('#filters').data('clicked')) {
      //when filter button clicked, set initial value for counter
      counter = initShow;
      $('#filters').data('clicked', false);
    } else {
      counter = counter;
    };

    counter = counter + initShow;

    loadMore(counter);
  });

  //when filter button clicked
  $("#filters").click(function() {
    $(this).data('clicked', true);

    loadMore(initShow);
  });
    }

  }
  
  
  $(document).ready(function() {
    masonry();
    stickyHeader();
    faq();
    filter_sidebar();
    view_column();
    search();
    portfolio();
    new WOW().init();
    headerToggle();
        $('.grid--view-items .grid-item').matchHeight({byRow: true, property: 'height'});

  });

 $(window).on('load resize', function() {
    sticky_sidebar();
    });

})(jQuery);
